import { createSelector } from "reselect";

export const getRequesting = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.requesting;
};
export const selectResponseMatrix = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.responseMatrix;
};

export const getGroups = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.groups;
};

export const getSelectedTemplate = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.copyTemplate;
};

export const getItems = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.items;
};

export const getTemplates = ({ Hsqe_reducer }) => {
    return Hsqe_reducer.templates;
};

export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level] ? config[access_level] : false;
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config["hsqe_template"] ? config["hsqe_template"].read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["hsqe_template"] ? config["hsqe_template"].update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["hsqe_template"] ? config["hsqe_template"].create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["hsqe_template"] ? config["hsqe_template"].delete : true;
    }
);

export const selectGroup = createSelector([getGroups], (groups) => {
    if (groups === false || typeof groups === "undefined" || groups === null) {
        return [];
    }

    let regGroups = Object.keys(groups).map((e) => {
        return groups[e];
    });

    return regGroups;
});

export const selectItem = createSelector([getItems], (items) => {
    if (items === false || typeof items === "undefined" || items === null) {
        return [];
    }

    let regItems = Object.keys(items).map((e) => {
        return items[e];
    });

    return regItems;
});

export const selectTemplate = createSelector([getTemplates], (templates) => {
    if (
        templates === false ||
        typeof templates === "undefined" ||
        templates === null
    ) {
        return [];
    }

    let regTemplates = Object.keys(templates).map((e) => {
        return templates[e];
    });
    return regTemplates;
});

export const selectTemplateName = createSelector(
    [getTemplates],
    (templates) => {
        let titleArr = [];
        if (
            templates === false ||
            typeof templates === "undefined" ||
            templates === null
        ) {
            return [];
        }

        Object.values(templates).map((e) => {
            titleArr.push(e.profile.report_title);
            return null;
        });
        return titleArr;
    }
);
